var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$route.meta.hideSplash
    ? _c(
        "div",
        { staticClass: "mui-col-md-6 mui-col-md-offset-3 mui-panel panel" },
        [_c("router-view", { key: _vm.$route.fullPath })],
        1
      )
    : _c("div", [
        _c("div", { staticClass: "site-info mui-col-md-7" }, [
          _c("div", {
            staticClass: "heading",
            domProps: { innerHTML: _vm._s(_vm.heading) },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "body",
            domProps: { innerHTML: _vm._s(_vm.body) },
          }),
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "mui-col-md-1",
          staticStyle: { "min-height": "15px" },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "login-form mui-col-md-4 mui-panel panel" },
          [_c("router-view", { key: _vm.$route.fullPath })],
          1
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }